<template>
  <div class="row" v-if="purchases.total > 0 || section.id == 2">
    <div class="col-12 bg-lightgrey p-2">
      <h3 class="mb-0 fa-sm text-dark-blue pl-2">{{ section.name }}</h3>
    </div>
    <div class="col-12" v-loading="loading">
      <span
        class="p-2"
        :class="
          closeout_purchase_ids.length > 0
            ? 'has-interaction text-moon-blue'
            : 'text-grey'
        "
        @click="clearCloseoutMT"
      >
        <i
          class="fa fa-times"
          :class="closeout_purchase_ids.length > 0 ? 'text-red' : 'text-grey'"
        ></i>
        Clear Selection ({{ closeout_purchase_ids.length }} trades selected)
      </span>
      <el-table
        :data="purchases.data"
        style="width: 100%"
        class="fa-sm purchase-table"
      >
        <el-table-column align="center" prop="id" width="60px">
          <template slot-scope="scope">
            <input
              v-if="getDaysUntilExpiryMT(scope.row.invoice_due_date) > 0"
              type="checkbox"
              class="mr-2"
              v-model="closeout_purchase_ids"
              :value="scope.row.id"
              :disabled="validateBusinessMT(scope.row)"
              @change="selectBusinessMT($event, scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" prop="id" label="Trade #" width="70px">
          <template slot-scope="scope">
            {{ scope.row.ref_id }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="business.name" label="Producer">
          <template slot-scope="scope">
            <a
              v-if="scope.row && scope.row.business"
              :href="`/businesses/${scope.row.business_id}`"
            >
              {{ scope.row.business.short_name }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="invoice_due_date"
          label="Days until expiry"
        >
          <template slot-scope="scope">
            {{ getDaysUntilExpiryMT(scope.row.invoice_due_date) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="reference_code" label="Reference">
        </el-table-column>
        <el-table-column align="center" prop="open_heads" label="Open Hd">
          <template slot-scope="scope">
            <div>
              {{ scope.row.open_heads ? scope.row.open_heads : 0 }}
              <el-button
                v-if="scope.row.open_heads > 0"
                type="text"
                icon="el-icon-download"
                @click="downloadHeadsMT(scope.row, false)"
              ></el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="open_head" label="Head off PIC">
          <template slot-scope="scope">
            {{ scope.row.purchase_assets_open_off_pic_count }}
            <el-button
              v-if="scope.row.purchase_assets_open_off_pic_count > 0"
              type="text"
              icon="el-icon-download"
              @click="downloadHeadsMT(scope.row, true)"
            ></el-button>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="livestock_class.name"
          label="Stock"
          width="60px"
        >
          <template slot-scope="scope">
            {{ scope.row.livestock_class.name.substring(0, 1) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop=""
          label="Contract Balance (Today)"
        >
          <template slot="header" slot-scope="scope">
            Balance
            <el-tooltip content="Livestock + Mgmt Fee" placement="bottom">
              <i class="fas fa-info-circle"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            {{
              scope.row.contract_balance_to_date
                ? "$" +
                  $_toLocaleString(
                    scope.row.contract_balance_to_date.contract_balance_inc_gst,
                    2
                  )
                : "--"
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="invoice_due_date" label="Expiry">
          <template slot-scope="scope">
            {{
              scope.row.invoice_due_date
                ? moment(scope.row.invoice_due_date).format("DD.MM.YYYY")
                : "--"
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="term" label="Term" width="70px">
        </el-table-column>
        <el-table-column
          align="center"
          prop="open_head"
          label="Action"
          width="115px"
        >
          <template slot-scope="scope">
            <div
              class="alert py-0 text-center m-0"
              :class="getActionTypeMT(scope.row.invoice_due_date)"
            >
              {{ getActionMT(scope.row.invoice_due_date) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" width="155">
          <template slot="header" slot-scope="scope">
            <el-dropdown
              class="p-0"
              @command="closeoutPurchaseMT($event)"
              :disabled="store_closeout_purchase_ids.length <= 1"
            >
              <el-button type="primary" size="mini" class="btn-primary">
                Multi closeout <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="invoiceType.id"
                  v-for="invoiceType in invoiceTypes"
                  :key="invoiceType.id"
                >
                  Multi {{ invoiceType.name }} ({{
                    store_closeout_purchase_ids.length
                  }})
                </el-dropdown-item>
                <hr class="mx-1 my-1" />
                <el-dropdown-item command="0"
                  >Get values to refinance ({{
                    store_closeout_purchase_ids.length
                  }})</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <el-dropdown
              v-if="getDaysUntilExpiryMT(scope.row.invoice_due_date) > 0"
              class="p-0"
              @command="closeoutPurchaseMT($event, scope.row)"
              :disabled="store_closeout_purchase_ids.length >= 1"
            >
              <el-button type="primary" size="mini" class="btn-primary">
                Closeout <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="invoiceType.id"
                  v-for="invoiceType in invoiceTypes"
                  :key="invoiceType.id"
                >
                  {{ invoiceType.name }}
                </el-dropdown-item>
                <hr class="mx-1 my-1" />
                <el-dropdown-item command="0"
                  >Get values to refinance</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <div class="text-danger" v-else>Contact Ottley</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="open_head"
          label="INV"
          width="50px"
        >
          <template slot-scope="scope">
            <invoice-button :initial_purchase="scope.row"></invoice-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="col-12 py-3 d-flex justify-content-center justify-content-xl-end"
      v-if="purchases.total > perPage"
    >
      <el-pagination
        layout="prev, pager, next, total"
        :current-page.sync="currentPage"
        @current-change="getData()"
        @prev-click="handlePrev"
        @next-click="handleNext"
        prev-text="Prev"
        next-text="Next"
        :background="true"
        :page-size="perPage"
        :page-count="purchases.last_page"
        :total="purchases.total"
      />
    </div>
    <payout-closeout-modal
      v-if="payoutModalShow"
      :closeout_purchases="closeout_purchases"
      :animals_sold="animals_sold"
      :closeout_livestock_class_id="closeout_livestock_class_id"
      :closeout_business="closeout_business"
      @close="closeModalMT"
      @refresh="refresh"
    ></payout-closeout-modal>
    <refinance-closeout-modal
      v-if="refinanceModalShow"
      :closeout_purchases="closeout_purchases"
      :closeout_livestock_class_id="closeout_livestock_class_id"
      :closeout_business="closeout_business"
      @close="closeModalMT"
      @refresh="refresh"
    ></refinance-closeout-modal>
    <values-to-refinance-closeout-modal
      v-if="valuesToRefinanceModalShow"
      :closeout_purchases="closeout_purchases"
      :closeout_livestock_class_id="closeout_livestock_class_id"
      :closeout_business="closeout_business"
      @close="closeModalMT"
    ></values-to-refinance-closeout-modal>
  </div>
</template>

<script>
import Purchase from "../../../modelsPortal/Purchase";
import OttleyFormatter from "../../../../mixins/OttleyFormatter";
import MaxTerm from "../../../../mixins/MaxTerm";
import PayoutCloseoutModal from "../../../../common/PayoutCloseoutModal.vue";
import RefinanceCloseoutModal from "../../../../common/RefinanceCloseoutModal.vue";
import ValuesToRefinanceCloseoutModal from "../../../../common/ValuesToRefinanceCloseoutModal.vue";
export default {
  components: {
    PayoutCloseoutModal,
    RefinanceCloseoutModal,
    ValuesToRefinanceCloseoutModal,
  },
  mixins: [OttleyFormatter, MaxTerm],
  props: {
    invoiceTypes: {
      type: Array,
    },
    filter: {
      type: Object,
    },
    section: {
      type: Object,
    },
  },

  data() {
    return {
      purchases: {},
      perPage: 20,
      currentPage: 1,
      loading: false,
      open: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    refresh() {
      this.refreshMT();
      this.$emit("refresh");
    },
    async getData() {
      if (this.filter.direction_id) {
        this.purchases = {};
        return;
      }
      this.loading = true;

      let purchases = new Purchase()
        .select({
          business: ["id", "name", "short_name"],
          purchases: [
            "id",
            "ref_id",
            "reference_code",
            "invoice_due_date",
            "invoice_invoice_date",
            "business_id",
            "livestock_class_id",
            "term",
            "average_weight",
          ],
          livestockClass: ["id", "name"],
          closeouts: [
            "id",
            "type_id",
            "purchase_id",
            "status_id",
            "user_id",
            "sale_id",
          ],
          "closeouts.sale": ["ref_id", "id"],
          livestockClass: ["id", "name"],
          closeouts: ["id", "type_id", "purchase_id", "status_id", "user_id"],
        })
        .append(
          "latest_balance",
          "dof",
          "contract_balance_to_date",
          "open_heads"
        )
        .include(
          "business",
          "livestockClass",
          "livestockClass",
          "closeouts.invoiceType",
          "closeouts",
          "closeouts.sale",
          "invoiceCollections"
        );

      if (this.orderBy) {
        purchases.orderBy(this.orderBy);
      } else {
        purchases.orderBy("invoice_due_date");
      }

      if (this.filter.query) {
        purchases.where("where_like", this.filter.query);
      }

      if (this.filter.business_ids) {
        purchases.whereIn("business_id", this.filter.business_ids);
      }
      if (this.filter.expiry_id) {
        purchases.where("expiry_date_filter", this.filter.expiry_id);
      }

      if (this.filter.dof) {
        purchases.whereIn("days_of_feed_filter", this.filter.dof);
      }

      purchases.where("max_term_pending", 4);
      purchases.where("has_closeouts", false);
      purchases.where("is_bt_overridden", false);

      purchases
        .page(this.currentPage)
        .params({ per_page: this.perPage, asset_off_pic: true });

      await purchases
        .get()
        .then((res) => {
          this.purchases = res;
        })
        .catch((errors) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    handleNext() {
      this.currentPage++;
    },
    handlePrev() {
      this.currentPage > 1 && this.currentPage--;
    },
  },
};
</script>
